import axios from "axios";
import { GetServiceSetData, GetSubscriptionSetData } from "./ServiceDatasTS";
import moment from "moment";
const isDevMode = process.env.NODE_ENV === "development" ? true : false;

// 비밀번호 자동 변경 지원하는 subs 인지 체크
export const checkIsPwAutoChangeSubs = (subsId: number) => {
  if (
    subsId === 1001 ||
    subsId === 1002 ||
    subsId === 1003 ||
    subsId === 1100 ||
    subsId === 2000 ||
    subsId === 3000 ||
    subsId === 4000 ||
    subsId === 4001 ||
    subsId === 5000 ||
    subsId === 5001 ||
    subsId === 16000
  ) {
    return true;
  } else {
    return false;
  }
};

// 비밀번호 자동 변경
export const pwAutoChangeMain = async (
  subsId: number,
  id: string,
  oldPw: string,
  newPw: string
) => {
  // 디즈니면, 다른 루트로 보낸다.
  if (subsId === 5000 || subsId === 5001) {
    // pwAutoChangeMain_Disney_0(id, newPw);
    const data = pwAutoChangeMain_Disney_0(id, newPw);
    return data;
  }

  const svcId = GetSubscriptionSetData(subsId ?? 0)?.SVC_ID ?? 0;
  let servEngName =
    GetServiceSetData(svcId)?.SVC_NM_TEMP?.toLocaleLowerCase() ?? "";

  // 넷플 추가공유는 넷플과 같은 패킷을 사용한다.
  if (svcId === 110) {
    servEngName =
      GetServiceSetData(100)?.SVC_NM_TEMP?.toLocaleLowerCase() ?? "";
  }

  const body = {
    id,
    pw: oldPw,
    pw_new: newPw,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_${servEngName}`;
  } else {
    addr = `/checker/pwchange_${servEngName}`;
  }

  try {
    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};

const pwAutoChangeMain_Disney_0 = async (id: string, newPw: string) => {
  const pw_new = newPw;
  const id_ori = id;

  let tokenValue = "";
  const data1 = await pwAutoChangeMain_Disney_1(id_ori, pw_new);
  // console.log("11111", data1);
  if (data1?.data?.isValid === true) {
    tokenValue = data1?.data?.token?.accessToken;
    const data2 = await pwAutoChangeMain_Disney_2(id_ori, tokenValue, newPw);
    // console.log("22222", data2);

    if (data2?.data?.reqEmail === true) {
      const now = moment().format("YYYY-MM-DD HH:mm:ss");
      const data3 = await pwAutoChangeMain_Disney_3(id_ori, now, 0);
      // console.log("33333", data3);

      if (data3?.data?.findEmail === true) {
        const data4 = await pwAutoChangeMain_Disney_4(
          id_ori,
          data3?.data?.otp,
          tokenValue
        );
        // console.log("44444", data4);
        if (data4?.data?.isSuccess === true) {
          const data5 = await pwAutoChangeMain_Disney_5(
            tokenValue,
            data4?.data?.actionGrant,
            pw_new
          );
          // console.log("55555", data5);
          if (data5?.data?.isSuccess === true) {
            let retData = {
              hasChanged: true,
              pw_new: data5?.data?.pw_new,
            };
            let data = {
              data: retData,
            };
            return data;
          } else {
            // 5실패
            return "error 5";
          }
        } else {
          // 4실패
          return "error 4";
        }
      } else {
        // 3실패
        return "error 3";
      }
    } else {
      // 2실패
      return "error 2";
    }
  } else {
    // 1 실패
    return "error 1";
  }

  return;
};

export const pwAutoChangeMain_Disney_1 = async (id: string, pw_new: string) => {
  const body = {
    id,
    pw_new: pw_new,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_disney_getToken`;
  } else {
    addr = `/checker/pwchange_disney_getToken`;
  }

  try {
    const res = await axios.post(addr, body);
    // console.log(res?.data?.data);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};

export const pwAutoChangeMain_Disney_2 = async (
  id: string,
  token: string,
  pw_new: string
) => {
  const body = {
    id,
    token: token,
    pw_new: pw_new,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_disney_requestEmail`;
  } else {
    addr = `/checker/pwchange_disney_requestEmail`;
  }

  try {
    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};

export const pwAutoChangeMain_Disney_3 = async (
  id: string,
  now: string,
  trycnt: number
) => {
  const body = {
    id,
    now: now,
    trycnt: trycnt,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_disney_checkEmailOTP`;
  } else {
    addr = `/checker/pwchange_disney_checkEmailOTP`;
  }

  try {
    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};

export const pwAutoChangeMain_Disney_4 = async (
  id: string,
  otp: string,
  token: string
) => {
  const body = {
    id,
    otp: otp,
    token: token,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_disney_otpVerify`;
  } else {
    addr = `/checker/pwchange_disney_otpVerify`;
  }

  try {
    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};

export const pwAutoChangeMain_Disney_5 = async (
  token: string,
  actionGrant: string,
  pw_new: string
) => {
  const body = {
    token,
    actionGrant: actionGrant,
    pw_new: pw_new,
  };

  let addr;

  if (isDevMode) {
    addr = `/pwChange/pwchange_disney_setNewPW`;
  } else {
    addr = `/checker/pwchange_disney_setNewPW`;
  }

  try {
    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("🚨 error: ", error);
  }
};
